import React from 'react';
import { CalendarIcon } from '../../icons/FontAwesomeIcon';
import '../../styles/components/UserTicket.css';

// Component to display a date slot with an icon
export function DateSlotWithIcon() {
    return (
        <div className="date-slot-with-icon-container">
            {/* Calendar Icon */}
            <div className="date-calendar-icon">
                <CalendarIcon style={{ color: '#26C1E8', fontSize: '1.125rem' }} />
            </div>
            {/* Date and Time Slot */}
            <div className="date-time-slot-container">
                <div className="date-slot-container">
                    <p>12th June 2025</p>
                </div>
                <div className="time-slot-container">
                    <p>12:00 PM To 4.00 PM</p>
                </div>
            </div>
        </div>
    );
}

// Component to display ticket details including title, description, and valid date slots
export function UserTicketDetailsSection() {
    return (
        <div className="user-ticket-details-section-container">
            {/* Ticket Title and Description */}
            <div className="user-ticket-title-desc-section">
                <div className="user-ticket-title">
                    <h2>Summer Music Festival Concert 2025</h2>
                </div>
                <div className="user-ticket-desc">
                    <p>
                        This ticket grants access to the event on the specified date and time.
                        Please arrive early to secure your seat.
                    </p>
                </div>
            </div>
            {/* Valid Date Slots */}
            <div className="user-ticket-dates-slot-section">
                <div className="user-ticket-valid-label">
                    <h3>Ticket is valid for</h3>
                </div>
                <div className="user-ticket-valid-date-slot">
                    {/* Multiple DateSlotWithIcon components */}
                    <DateSlotWithIcon />
                    <DateSlotWithIcon />
                </div>
            </div>
        </div>
    );
}

// Component to display user ticket action details such as ticket number and user name
export function UserTicketActionSection() {
    return (
        <div className="user-ticket-action-section-container">
            {/* Ticket Number and User Name */}
            <div className="user-ticket-number-section">
                <p>Ticket No.</p>
                <p>1532478965</p>
            </div>
            <div className="user-ticket-name-section">
                <p>Prashant Chaute</p>
            </div>
        </div>
    );
}

// Component to display a visual separator section in the ticket layout
export function UserTicketSeparatorSection() {
    return (
        <div className="user-ticket-separator-section-container">
            {/* Separator Components */}
            <div className="user-ticket-top"></div>
            <div className="user-ticket-dashed"></div>
            <div className="user-ticket-bottom"></div>
        </div>
    );
}

// Main UserTicket component that composes all the above sections
export default function UserTicket() {
    return (
        <div className="user-ticket-layout-container">
            <UserTicketDetailsSection />
            <UserTicketSeparatorSection />
            <UserTicketActionSection />
        </div>
    );
}
